// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZQf1","colMin":"styles_colMin__vTqj4"};